import axios from "axios";

export default axios.create({
  baseURL: "https://elmsbkd.aeontechhub.com",
});
